import { Phone, MessageCircle } from "lucide-react";
import { Button } from "../ui/button";
import { useLanguage } from "../../contexts/LanguageContext";

export const MobileStickyBar = () => {
  const { translations: t } = useLanguage();
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-3 bg-[#2C2C2C] flex gap-2 md:hidden" data-testid="mobile-sticky-cta">
      <a href="tel:052-3824500" className="flex-1">
        <Button className="w-full rounded-full bg-[#C4956A] hover:bg-[#b38559] text-white py-5">
          <Phone className="w-5 h-5 mx-2" />
          {t.mobileBar.call}
        </Button>
      </a>
      <a href="https://wa.me/972523824500" target="_blank" rel="noopener noreferrer" className="flex-1">
        <Button className="w-full rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white py-5">
          <MessageCircle className="w-5 h-5 mx-2" />
          {t.mobileBar.whatsapp}
        </Button>
      </a>
    </div>
  );
};
